@if (data.mobileType === "android") {
	<mat-toolbar color="primary" class="android-prompt">
		<button mat-button (click)="installPwa()">Add to Home screen</button>
		<button mat-icon-button (click)="close()">
			<span class="material-symbols-sharp">close</span>
		</button>
	</mat-toolbar>
}

@if (data.mobileType === "ios") {
	<div class="ios-prompt">
		<button class="close-ios-inv" mat-button color="primary" (click)="close()">
			<span class="material-symbols-sharp">close</span>
		</button>
		<div>
			To install this web app on your device tap the Menu button and then 'Add to
			Home screen' button
		</div>
		<div>
			<img src="./assets/img/ios-menu-btn.png" />
			<span class="material-symbols-sharp">navigate_next</span>
			<img src="./assets/img/ios-add-btn.png" />
		</div>
	</div>
}
